import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SKIP_LOADING } from 'interceptor/peticion-api.interceptor';
import { API_DESC } from 'interceptor/peticion-history.interceptor';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ApiDashboardService {

  private http = inject(HttpClient)

  get<T>(url: string, params?: HttpParams, descri: string = 'DESCONOCIDO') {
    const context = new HttpContext()
      .set(SKIP_LOADING, true)
      .set(API_DESC, descri)
    if (params) {
      return this.http.get<T>(url, { params, context })
    }
    return this.http.get<T>(url, { context })
  }

  put<T>(url: string, body?: T, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<any> {
    const context = new HttpContext()
      .set(SKIP_LOADING, true)
      .set(API_DESC, descri)
    if (params) {
      return this.http.put<any>(url, body, { context, params })
    }
    return this.http.put<any>(url, body, { context })
  }

  delete(url: string, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<any> {
    const context = new HttpContext()
      .set(SKIP_LOADING, true)
      .set(API_DESC, descri)
    if (params) {
      return this.http.delete<any>(url, { context, params })
    }
    return this.http.delete<any>(url, { context })
  }
}